import { Point } from 'chart.js';

import { MFBEvent } from 'types/models/event';
import Sample, { SampleDate } from 'types/models/sample';
import { MergedSamplePoint, SamplePointId, SensorTagId } from 'types/models/samplePoint';
import { TriggerMessage } from 'types/trigger.enum';

// ==============================
// Raw asset types
// ==============================
const HEATER_SENSOR_TYPES = [
  SensorTagId.XTEND_HEATED_TROUGH_MACHINE_CYCLES,
  SensorTagId.XTEND_HEATED_TROUGH_POWER,
  SensorTagId.XTEND_HEATED_TROUGH_STATUS_FLAGS,
  SensorTagId.XTEND_HEATED_TROUGH_SUPPLY_CURRENT,
  SensorTagId.XTEND_HEATED_TROUGH_SUPPLY_VOLTS,
  SensorTagId.XTEND_HEATED_TROUGH_TEMPERATURE
] as const;

const HEATER_SENSOR_TYPE_SET: Set<SensorTagId> = new Set(HEATER_SENSOR_TYPES);

export const isHeaterSensorType = (sensorId: SensorTagId): boolean => {
  return HEATER_SENSOR_TYPE_SET.has(sensorId);
};

export type HeaterSensorType = typeof HEATER_SENSOR_TYPES[number];

// ==============================
// Merged sample point
// ==============================
export type HeaterAssociatedSamplePointIds = {
  cycle?: SamplePointId;
  energy?: SamplePointId;
  onOff?: SamplePointId;
  supplyCurrent?: SamplePointId;
  supplyVoltage?: SamplePointId;
  temperature?: SamplePointId;
};

export type SamplePointWithHeaterAddOn = MergedSamplePoint<{
  heater: HeaterAssociatedSamplePointIds
}>;

// ==============================
// Merged sample
// ==============================
export type HeaterSubSample = Pick<Sample, 'rwValue' | 'errorCode' | 'statusCode'>;

export type HeaterSample = {
  date: SampleDate,
  seqNo: Sample['extraValues']['seqNo']
} & Partial<{
  energy: HeaterSubSample,
  onOff: HeaterSubSample,
  temperature: HeaterSubSample
}>;

// ==============================
// Misc.
// ==============================
export enum HeaterStatus {
  OFF = 'Off',
  ON = 'On'
}

export type HeaterPowerIssueEvent = Pick<MFBEvent, 'date'> & {
  message: TriggerMessage.HEATER_POWER_SUPPLY_ISSUE | TriggerMessage.HEATER_POWER_SUPPLY_RECOVERED;
};

export type HeaterPowerIssueChartPoint = Pick<Point, 'x'> & {
  /** 1 = issue, 0 = recovered */
  y: 1 | 0;
};